import {
  FORM_ADD_PAYTO_MAX_AMOUNT_NAME,
  FORM_ADD_PAYTO_PAYID_TYPE_NAME,
  PAYTO_LOG_TAG,
  RESET_FORM_ADD_PAYTO_ACCOUNT_STORE,
} from 'features/to/const';
import usePaytoStore from 'features/to/hooks/payment/usePaytoStore';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import withRoundUpPaytoMaxAmount from './withRoundUpPaytoMaxAmount';

const withAddPaytoPayIdAccountManual = (Component) => {
  const AddPaytoPayIdAccountManualComponent = withRoundUpPaytoMaxAmount(
    (props) => {
      const {
        setAddManual,
        setAddPayIdManual,
        paytoAccountInformationRetry,
        setPaytoAccountValidation,
        maxAmountInitialVer2,
      } = props || {};

      const { setPaytoAccountInformation, setPaytoPayIdBankValidationFailure } =
        usePaytoStore();

      const [numberMaskStr, setNumberMaskStr] = useState('');

      useEffect(() => {
        if (!isEmpty(paytoAccountInformationRetry)) return;
        setNumberMaskStr('');
      }, [paytoAccountInformationRetry]);

      const handleUsePayIdPaytoAccountOnSelect = () => {
        const payload = {
          ...RESET_FORM_ADD_PAYTO_ACCOUNT_STORE,
          [FORM_ADD_PAYTO_MAX_AMOUNT_NAME]: `${maxAmountInitialVer2}`,
          id: 'payid',
        };
        console.log(
          `⭐ ${PAYTO_LOG_TAG} 👉 handleUsePayIdPaytoAccountOnSelect ➡️ payload ↩`,
          payload
        );
        setPaytoAccountInformation(payload);

        let newValidation = { ...RESET_FORM_ADD_PAYTO_ACCOUNT_STORE };
        delete newValidation?.[FORM_ADD_PAYTO_PAYID_TYPE_NAME];
        setPaytoAccountValidation(newValidation);

        // DEV-1401: a prior PayID attempt's bank-validation-failure flag
        // must not leak into a fresh entry into this same PayID flow (e.g.
        // switch to BSB, then back to PayID) and render the failure row
        // before any new validation has run.
        setPaytoPayIdBankValidationFailure(false);

        setAddPayIdManual(true);
        setAddManual(false);
      };

      const newProps = {
        ...props,
        numberMaskStr,
        setNumberMaskStr,
      };
      return (
        <Component
          {...newProps}
          onSelect={handleUsePayIdPaytoAccountOnSelect}
        />
      );
    }
  );
  return AddPaytoPayIdAccountManualComponent;
};

export default withAddPaytoPayIdAccountManual;
